const CONEXION = Object.freeze({
  paez: {
    nombre: "paez",
    conexionpagoweb: `https://paez.pagosweb.com.ve/intra`,

    reportespagoweb: "https://paez.pagosweb.com.ve/intra/paez?",
    adjunto: true,
    declarar_con_deuda: false,
    conexion: "http://localhost:2300",
    conexionbackup: "ws://172.16.0.2:2100",
    conexionsiapactu: "ws://172.16.0.2:2020",
    logocatastro: "catastrologo.png",
    servidor: "http://localhost",
    conexionweb: "http://localhost:2100",
    municipio: "paez",
    imagenes: "http://localhost:2100",
    icon: "paez.ico",
    logoEscudo: "",
    logologin: "logopaez.png",
    logohacienda: "logopaez.png",
    color: "rgb(1, 156, 213)",
    cne: "http://172.16.0.2:2200",
    reportes: "http://172.16.0.2:2100/siap",
    email: "http://172.16.0.2:5000",
    alcaldia: "Alcaldía del Municipio PAez",
    correo: "alcaldiadelmunicipiopaez@gmail.com",
    rif: "G-20002730-4",
    agylsoft: false,
    espiritu: {
      0: {
        email: "info.admpaez@gmail.com",
        clave: "lblgwzffupxkpjed",
      },
      1: {
        email: "info.alcaldiaesteller@gmail.com",
        clave: "esteller0324",
      },
      2: {
        email: "info.alcaldiaturen@gmail.com",
        clave: "turen123",
      },
      3: {
        email: "info.concejopaez@gmail.com",
        clave: "concejo0324",
      },
      15: {
        email: "info.admguanare@gmail.com",
        clave: "uigxltxiwzhkejdj",
      },
      25: {
        email: "satebcocorreos2022@gmail.com",
        clave: "qggzmgginhjfnspf",
      },
    },
    estilos: {
      color: "#019cd5",
      btnIngresar: {
        color: "#fffb00",
        border: "none",
      },
      btnRecuperar: {
        color: "#fffb00",
        border: "none",
        fontSize: "14px",
      },
    },
  },
  paezweb: {
    nombre: "paez",
    conexionpagoweb: `https://paez.pagosweb.com.ve/intra`,

    reportespagoweb: "https://paez.pagosweb.com.ve/intra/paez?",
    adjunto: true,
    declarar_con_deuda: false,
    conexionbackup: "wss://paez.opensiap.com.ve/api/ws",
    conexionsiapactu: "wss://paez.opensiap.com.ve/api/socket",
    conexioncapture: "https://paez.pagosweb.com.ve",
    servidor: "https://paez.opensiap.com.ve/api",
    conexion: "https://paez.opensiap.com.ve/api",
    conexionmap: "https://paez.opensiap.com.ve/mapa",
    icon: "paez.ico",
    logoEscudo: "",
    logologin: "logopaez.png",
    logohacienda: "logopaez.png",
    conexionweb: "https://paez.opensiap.com.ve/api",
    municipio: "guanare",
    imagenes: "https://paez.opensiap.com.ve/api",
    imagenreportes: "https://paez.opensiap.com.ve/api",
    color: "rgb(1, 156, 213)",
    cne: "http://localhost:2200",
    reportes: "https://paez.opensiap.com.ve/api/siap",
    email: "http://localhost:5000",
    alcaldia: "Alcaldía del Municipio Paez",
    correo: "alcaldiadelmunicipioezequielzamora@gmail.com",
    rif: "G-20002730-4",
    logocatastro: "catastrologo.png",
    admin: 0,
    agylsoft: false,
    espiritu: {
      0: {
        email: "info.admpaez@gmail.com",
        clave: "lblgwzffupxkpjed",
      },
      1: {
        email: "info.alcaldiaesteller@gmail.com",
        clave: "esteller0324",
      },
      2: {
        email: "info.alcaldiaturen@gmail.com",
        clave: "turen123",
      },
      3: {
        email: "info.concejopaez@gmail.com",
        clave: "concejo0324",
      },
      15: {
        email: "info.admguanare@gmail.com",
        clave: "uigxltxiwzhkejdj",
      },
      25: {
        email: "satebcocorreos2022@gmail.com",
        clave: "qggzmgginhjfnspf",
      },
    },
  },
  satrimsca: {
    conexion: "http://192.168.0.254:2300",
    servidor: "http://192.168.0.254",
    conexionweb: "http://192.168.0.254:2100",
    municipio: "paez",
    imagenes: "http://192.168.0.254:2300",
    icon: "logo.ico",
    logoEscudo: "",
    logologin: "sancarlos_original.png",
    logohacienda: "SETRIMSCA-azul.png",
    color: "rgb(1, 156, 213)",
    cne: "http://192.168.0.254:2200",
    reportes: "http://192.168.0.254:2300/siap",
    email: "http://192.168.0.254:5000",
    alcaldia: "Alcaldía del Municipio San Carlos",
    correo: " ",
    rif: " ",
    agylsoft: false,
    espiritu: {
      0: {
        email: "info.admpaez@gmail.com",
        clave: "lblgwzffupxkpjed",
      },
      1: {
        email: "info.alcaldiaesteller@gmail.com",
        clave: "esteller0324",
      },
      2: {
        email: "info.alcaldiaturen@gmail.com",
        clave: "turen123",
      },
      3: {
        email: "info.concejopaez@gmail.com",
        clave: "concejo0324",
      },
      15: {
        email: "info.admguanare@gmail.com",
        clave: "uigxltxiwzhkejdj",
      },
      25: {
        email: "satebcocorreos2022@gmail.com",
        clave: "qggzmgginhjfnspf",
      },
    },
  },
  servechen: {
    nombre: "paez",
    conexionpagoweb: `https://paez.pagosweb.com.ve/intra`,

    reportespagoweb: "https://paez.pagosweb.com.ve/intra/paez?",
    adjunto: true,
    declarar_con_deuda: false,
    conexionbackup: "wss://sistema.opensiap.com.ve/api/ws",
    conexionsiapactu: "wss://sistema.opensiap.com.ve/api/socket",
    servidor: "https://sistema.opensiap.com.ve/api",
    conexion: "https://sistema.opensiap.com.ve/api",
    conexionmap: "https://sistema.opensiap.com.ve/mapa",
    icon: "paez.ico",
    logoEscudo: "",
    logologin: "logopaez.png",
    logohacienda: "logopaez.png",
    conexionweb: "https://sistema.opensiap.com.ve/api",
    municipio: "guanare",
    imagenes: "https://sistema.opensiap.com.ve/api",
    imagenreportes: "https://sistema.opensiap.com.ve/api",
    color: "rgb(1, 156, 213)",
    cne: "http://localhost:2200",
    reportes: "https://sistema.opensiap.com.ve/api/siap",
    email: "http://localhost:5000",
    alcaldia: "Alcaldía del Municipio Ezequiel Zamora",
    correo: "alcaldiadelmunicipioezequielzamora@gmail.com",
    rif: "G-20002730-4",
    logocatastro: "catastrologo.png",

    agylsoft: false,
    espiritu: {
      0: {
        email: "info.admpaez@gmail.com",
        clave: "lblgwzffupxkpjed",
      },
      1: {
        email: "info.alcaldiaesteller@gmail.com",
        clave: "esteller0324",
      },
      2: {
        email: "info.alcaldiaturen@gmail.com",
        clave: "turen123",
      },
      3: {
        email: "info.concejopaez@gmail.com",
        clave: "concejo0324",
      },
      15: {
        email: "info.admguanare@gmail.com",
        clave: "uigxltxiwzhkejdj",
      },
      25: {
        email: "satebcocorreos2022@gmail.com",
        clave: "qggzmgginhjfnspf",
      },
    },
  },
  local: {
    nombre: "cppaez",
    ws: "https://comresis.opensiap.com.ve/ws",
    conexionpagoweb: `https://paez.pagosweb.com.ve/intra`,
    reportespagoweb: "https://paez.pagosweb.com.ve/intra/paez?",
    adjunto: true,
    declarar_con_deuda: false,
    conexionbackup: "localhost:2300",
    conexionsiapactu: "localhost:4300",
    conexioncapture: "https://paez.pagosweb.com.ve",
    conexion: "http://localhost" + ":2300",
    conexionmap: "localhost" + ":3500",
    servidor: "localhost",
    conexionweb: "http://192.168.0.212" + ":2100",
    municipio: "guanare",
    imagenes: "http://localhost" + ":2300",
    imagenreportes: "http://localhost" + ":2300",
    agylsoft: false,
    color: "rgb(1, 156, 213)",
    cne: "http://192.168.0.212" + ":2200",
    reportes: "http://localhost" + ":2300/siap",
    email: "http://localhost" + ":5000",
    icon: "paez.ico",
    logoEscudo: "escudo_admin.png",
    logologin: "logopaez.png",
    logohacienda: "logopaez.png",
    logocatastro: "logopaez.png",
    alcaldia: "Alcaldía del Municipio Ezequiel Zamora",
    correo: "alcaldiadelmunicipioezequielzamora@gmail.com",
    rif: "G-20002730-4",
    admin: 0,
    espiritu: {
      0: {
        email: "info.admpaez@gmail.com",
        clave: "lblgwzffupxkpjed",
      },
      1: {
        email: "info.alcaldiaesteller@gmail.com",
        clave: "esteller0324",
      },
      2: {
        email: "info.alcaldiaturen@gmail.com",
        clave: "turen123",
      },
      3: {
        email: "info.concejopaez@gmail.com",
        clave: "concejo0324",
      },
      15: {
        email: "info.admguanare@gmail.com",
        clave: "uigxltxiwzhkejdj",
      },
      25: {
        email: "satebcocorreos2022@gmail.com",
        clave: "qggzmgginhjfnspf",
      },
    },
  },
  cmguanare: {
    conexionbackup: "wss://cmguanare.opensiap.com.ve/api/ws",
    conexionsiapactu: "wss://cmguanare.opensiap.com.ve/api/socket",
    servidor: "https://cmguanare.opensiap.com.ve/api",
    conexion: "https://cmguanare.opensiap.com.ve/api",
    conexionmap: "https://cmguanare.opensiap.com.ve/mapa",
    //icon: "paez.ico",
    logoEscudo: "",
    logologin: "cmguanrelogo.png",
    logohacienda: "cmguanrelogo.png",
    conexionweb: "https://cmguanare.opensiap.com.ve/api",
    municipio: "guanare",
    imagenes: "https://cmguanare.opensiap.com.ve/api",
    imagenreportes: "https://cmguanare.opensiap.com.ve/api",
    color: "rgb(1, 156, 213)",
    cne: "http://localhost:2200",
    reportes: "https://cmguanare.opensiap.com.ve/api/siap",
    email: "http://localhost:5000",
    alcaldia: "Alcaldía del Municipio Guanare",
    correo: "alcaldiadelmunicipioezequielzamora@gmail.com",
    rif: "G-20002730-4",
    logocatastro: "catastrologo.png",

    agylsoft: false,
    espiritu: {
      0: {
        email: "info.admpaez@gmail.com",
        clave: "lblgwzffupxkpjed",
      },
      1: {
        email: "info.alcaldiaesteller@gmail.com",
        clave: "esteller0324",
      },
      2: {
        email: "info.alcaldiaturen@gmail.com",
        clave: "turen123",
      },
      3: {
        email: "info.concejopaez@gmail.com",
        clave: "concejo0324",
      },
      15: {
        email: "info.admguanare@gmail.com",
        clave: "uigxltxiwzhkejdj",
      },
      25: {
        email: "satebcocorreos2022@gmail.com",
        clave: "qggzmgginhjfnspf",
      },
    },
  },
  snrafael: {
    nombre: "snrafael",
    conexionpagoweb: ` `,

    reportespagoweb: " ",
    adjunto: true,
    declarar_con_deuda: false,
    conexionbackup: "wss://snrafael.opensiap.com.ve/api/ws",
    conexionsiapactu: "wss://snrafael.opensiap.com.ve/api/socket",
    conexioncapture: "https://paez.pagosweb.com.ve",
    servidor: "https://snrafael.opensiap.com.ve/api",
    conexion: "https://snrafael.opensiap.com.ve/api",
    conexionmap: "https://snrafael.opensiap.com.ve/mapa",
    icon: " ",
    logoEscudo: "",
    logologin: "LogoSro.png",
    logohacienda: "LogoSro.png",
    logocatastro: "LogoSro.png",
    conexionweb: "https://snrafael.opensiap.com.ve/api",
    municipio: "guanare",
    imagenes: "https://snrafael.opensiap.com.ve/api",
    imagenreportes: "https://snrafael.opensiap.com.ve/api",
    color: "rgb(1, 156, 213)",
    cne: "http://snrafael.opensiap.com.ve:4300",
    reportes: "https://snrafael.opensiap.com.ve/api/siap",
    email: "http://snrafael.opensiap.com.ve" + ":5000",
    alcaldia: "Alcaldía del Municipio Paez",
    correo: "alcaldiadelmunicipioezequielzamora@gmail.com",
    rif: "G-20002730-4",
    logocatastro: "catastrologo.png",
    admin: 0,
    agylsoft: false,
    espiritu: {
      0: {
        email: "info.admpaez@gmail.com",
        clave: "lblgwzffupxkpjed",
      },
      1: {
        email: "info.alcaldiaesteller@gmail.com",
        clave: "esteller0324",
      },
      2: {
        email: "info.alcaldiaturen@gmail.com",
        clave: "turen123",
      },
      3: {
        email: "info.concejopaez@gmail.com",
        clave: "concejo0324",
      },
      15: {
        email: "info.admguanare@gmail.com",
        clave: "uigxltxiwzhkejdj",
      },
      25: {
        email: "satebcocorreos2022@gmail.com",
        clave: "qggzmgginhjfnspf",
      },
    },
  },
  aguablanca: {
    nombre: "aguablanca",
    conexionpagoweb: ` `,

    reportespagoweb: " ",
    adjunto: true,
    declarar_con_deuda: false,
    conexionbackup: "wss://aguablanca.opensiap.com.ve/api/ws",
    conexionsiapactu: "wss://aguablanca.opensiap.com.ve/api/socket",
    conexioncapture: " ",
    servidor: "https://aguablanca.opensiap.com.ve",
    conexion: "https://aguablanca.opensiap.com.ve/api",
    conexionmap: "https://aguablanca.opensiap.com.ve/mapa",

    conexionweb: "http://192.168.0.212" + ":2100",
    municipio: "aguablanca",
    imagenes: "https://aguablanca.opensiap.com.ve/api",
    imagenreportes: "https://aguablanca.opensiap.com.ve/api",
    agylsoft: false,
    color: "rgb(1, 156, 213)",
    cne: "http://192.168.0.212" + ":2200",
    reportes: "https://aguablanca.opensiap.com.ve/api/siap",
    email: "http://localhost" + ":5000",
    icon: "aguablanca.ico",
    logoEscudo: "",
    logologin: "alcaldiaagua.png",
    logohacienda: "alcaldiaagua.png",
    logocatastro: "alcaldiaagua.png",
    alcaldia: "Alcaldía del Municipio Ezequiel Zamora",
    correo: "alcaldiadelmunicipioezequielzamora@gmail.com",
    rif: "G-20002730-4",
    admin: 0,
    espiritu: {
      0: {
        email: "info.admpaez@gmail.com",
        clave: "lblgwzffupxkpjed",
      },
      1: {
        email: "info.alcaldiaesteller@gmail.com",
        clave: "esteller0324",
      },
      2: {
        email: "info.alcaldiaturen@gmail.com",
        clave: "turen123",
      },
      3: {
        email: "info.concejopaez@gmail.com",
        clave: "concejo0324",
      },
      15: {
        email: "info.admguanare@gmail.com",
        clave: "uigxltxiwzhkejdj",
      },
      25: {
        email: "satebcocorreos2022@gmail.com",
        clave: "qggzmgginhjfnspf",
      },
    },
  },
  aguablancahac: {
    nombre: "aguablancahac",
    ws: "https://paez.opensiap.com.ve/ws",
    conexionpagoweb: ` `,
    reportespagoweb: " ",
    adjunto: true,
    declarar_con_deuda: false,
    conexionbackup: "wss://tributariaaguablanca.opensiap.com.ve/api/ws",
    conexionsiapactu: "wss://tributariaaguablanca.opensiap.com.ve/api/socket",
    conexioncapture: " ",
    servidor: "https://tributariaaguablanca.opensiap.com.ve",
    conexion: "https://tributariaaguablanca.opensiap.com.ve/api",
    conexionmap: "https://tributariaaguablanca.opensiap.com.ve/mapa",

    conexionweb: "http://192.168.0.212" + ":2100",
    municipio: "aguablancahac",
    imagenes: "https://tributariaaguablanca.opensiap.com.ve/api",
    imagenreportes: "https://tributariaaguablanca.opensiap.com.ve/api",
    agylsoft: false,
    color: "rgb(1, 156, 213)",
    cne: "http://192.168.0.212" + ":2200",
    reportes: "https://tributariaaguablanca.opensiap.com.ve/api/siap",
    email: "http://localhost" + ":5000",
    icon: "aguablanca.ico",
    logoEscudo: "",
    logologin: "alcaldiaagua.png",
    logohacienda: "alcaldiaagua.png",
    logocatastro: "alcaldiaagua.png",
    alcaldia: "Alcaldía del Municipio Ezequiel Zamora",
    correo: "alcaldiadelmunicipioezequielzamora@gmail.com",
    rif: "G-20002730-4",
    admin: 0,
    espiritu: {
      0: {
        email: "info.admpaez@gmail.com",
        clave: "lblgwzffupxkpjed",
      },
      1: {
        email: "info.alcaldiaesteller@gmail.com",
        clave: "esteller0324",
      },
      2: {
        email: "info.alcaldiaturen@gmail.com",
        clave: "turen123",
      },
      3: {
        email: "info.concejopaez@gmail.com",
        clave: "concejo0324",
      },
      15: {
        email: "info.admguanare@gmail.com",
        clave: "uigxltxiwzhkejdj",
      },
      25: {
        email: "satebcocorreos2022@gmail.com",
        clave: "qggzmgginhjfnspf",
      },
    },
  },
  admin: {
    nombre: "admin",
    conexionpagoweb: ` `,

    reportespagoweb: " ",
    adjunto: true,
    declarar_con_deuda: false,
    conexionbackup: "wss://admin.opensiap.com.ve/api/ws",
    conexionsiapactu: "wss://admin.opensiap.com.ve/api/socket",
    conexioncapture: " ",
    servidor: "https://admin.opensiap.com.ve",
    conexion: "https://admin.opensiap.com.ve/api",
    conexionmap: "https://admin.opensiap.com.ve/mapa",

    conexionweb: "http://192.168.0.212" + ":2100",
    municipio: "admin",
    imagenes: "https://admin.opensiap.com.ve/api",
    imagenreportes: "https://admin.opensiap.com.ve/api",
    agylsoft: false,
    color: "rgb(1, 156, 213)",
    cne: "http://192.168.0.212" + ":2200",
    reportes: "https://admin.opensiap.com.ve/api/siap",
    email: "http://localhost" + ":5000",
    icon: "paez.ico",
    logoEscudo: "escudo_admin.png",
    logologin: "LogoSro.png",
    logohacienda: "LogoSro.png",
    logocatastro: "LogoSro.png",
    alcaldia: "Alcaldía del Municipio Ezequiel Zamora",
    correo: "alcaldiadelmunicipioezequielzamora@gmail.com",
    rif: "G-20002730-4",
    admin: 1,
    espiritu: {
      0: {
        email: "info.admpaez@gmail.com",
        clave: "lblgwzffupxkpjed",
      },
      1: {
        email: "info.alcaldiaesteller@gmail.com",
        clave: "esteller0324",
      },
      2: {
        email: "info.alcaldiaturen@gmail.com",
        clave: "turen123",
      },
      3: {
        email: "info.concejopaez@gmail.com",
        clave: "concejo0324",
      },
      15: {
        email: "info.admguanare@gmail.com",
        clave: "uigxltxiwzhkejdj",
      },
      25: {
        email: "satebcocorreos2022@gmail.com",
        clave: "qggzmgginhjfnspf",
      },
    },
  },
  fcite: {
    nombre: "fcite",
    conexionpagoweb: ` `,

    reportespagoweb: " ",
    adjunto: true,
    declarar_con_deuda: false,
    conexionbackup: "wss://fundaciteportuguesa.opensiap.com.ve/api/ws",
    conexionsiapactu: "wss://fundaciteportuguesa.opensiap.com.ve/api/socket",
    conexioncapture: " ",
    servidor: "https://fundaciteportuguesa.opensiap.com.ve",
    conexion: "https://fundaciteportuguesa.opensiap.com.ve/api",
    conexionmap: "https://fundaciteportuguesa.opensiap.com.ve/mapa",

    conexionweb: "http://192.168.0.212" + ":2100",
    municipio: "admin",
    imagenes: "https://fundaciteportuguesa.opensiap.com.ve/api",
    imagenreportes: "https://fundaciteportuguesa.opensiap.com.ve/api",
    agylsoft: false,
    color: "rgb(1, 156, 213)",
    cne: "http://192.168.0.212" + ":2200",
    reportes: "https://fundaciteportuguesa.opensiap.com.ve/api/siap",
    email: "http://localhost" + ":5000",
    icon: "paez.ico",
    logoEscudo: "escudo_admin.png",
    logologin: "LogoSro.png",
    logohacienda: "LogoSro.png",
    logocatastro: "LogoSro.png",
    alcaldia: "Alcaldía del Municipio Ezequiel Zamora",
    correo: "alcaldiadelmunicipioezequielzamora@gmail.com",
    rif: "G-20002730-4",
    admin: 1,
    espiritu: {
      0: {
        email: "info.admpaez@gmail.com",
        clave: "lblgwzffupxkpjed",
      },
      1: {
        email: "info.alcaldiaesteller@gmail.com",
        clave: "esteller0324",
      },
      2: {
        email: "info.alcaldiaturen@gmail.com",
        clave: "turen123",
      },
      3: {
        email: "info.concejopaez@gmail.com",
        clave: "concejo0324",
      },
      15: {
        email: "info.admguanare@gmail.com",
        clave: "uigxltxiwzhkejdj",
      },
      25: {
        email: "satebcocorreos2022@gmail.com",
        clave: "qggzmgginhjfnspf",
      },
    },
  },
  opensiaptest: {
    nombre: "paez",
    conexionpagoweb: `https://gestion.pagosweb.com.ve/intra`,

    reportespagoweb: "https://gestion.pagosweb.com.ve/intra/paez?",
    adjunto: true,
    declarar_con_deuda: false,
    conexionbackup: "wss://gestion.opensiap.com.ve/api/ws",
    conexionsiapactu: "wss://gestion.opensiap.com.ve/api/socket",
    conexioncapture: "https://gestion.pagosweb.com.ve",
    servidor: "https://gestion.opensiap.com.ve/api",
    conexion: "https://gestion.opensiap.com.ve/api",
    conexionmap: "https://gestion.opensiap.com.ve/mapa",
    icon: "paez.ico",
    logoEscudo: "",
    logologin: "Logopsiap2.png",
    logohacienda: "Logopsiap2.png",
    conexionweb: "https://gestion.opensiap.com.ve/api",
    municipio: "guanare",
    imagenes: "https://gestion.opensiap.com.ve/api",
    imagenreportes: "https://gestion.opensiap.com.ve/api",
    color: "rgb(1, 156, 213)",
    cne: "http://localhost:2200",
    reportes: "https://gestion.opensiap.com.ve/api/siap",
    email: "http://localhost:5000",
    alcaldia: "Alcaldía del Municipio Paez",
    correo: "alcaldiadelmunicipioezequielzamora@gmail.com",
    rif: "G-20002730-4",
    logocatastro: "Logopsiap2.png",
    admin: 0,
    agylsoft: false,
    espiritu: {
      0: {
        email: "info.admpaez@gmail.com",
        clave: "lblgwzffupxkpjed",
      },
      1: {
        email: "info.alcaldiaesteller@gmail.com",
        clave: "esteller0324",
      },
      2: {
        email: "info.alcaldiaturen@gmail.com",
        clave: "turen123",
      },
      3: {
        email: "info.concejopaez@gmail.com",
        clave: "concejo0324",
      },
      15: {
        email: "info.admguanare@gmail.com",
        clave: "uigxltxiwzhkejdj",
      },
      25: {
        email: "satebcocorreos2022@gmail.com",
        clave: "qggzmgginhjfnspf",
      },
    },
  },
  sigat: {
    nombre: "sigat",
    conexionpagoweb: `https://sigat.pagosweb.com.ve/intra`,

    reportespagoweb: "https://sigat.pagosweb.com.ve/intra/paez?",
    adjunto: true,
    declarar_con_deuda: false,
    conexionbackup: "wss://sigat.opensiap.com.ve/api/ws",
    conexionsiapactu: "wss://sigat.opensiap.com.ve/api/socket",
    conexioncapture: "https://sigat.pagosweb.com.ve",
    servidor: "https://sigat.opensiap.com.ve/api",
    conexion: "https://sigat.opensiap.com.ve/api",
    conexionmap: "https://sigat.opensiap.com.ve/mapa",
    icon: "sigat.ico",
    logoEscudo: "",
    logologin: "sigat.png",
    logohacienda: "sigat.png",
    conexionweb: "https://sigat.opensiap.com.ve/api",
    municipio: "guanare",
    imagenes: "https://sigat.opensiap.com.ve/api",
    imagenreportes: "https://sigat.opensiap.com.ve/api",
    color: "rgb(1, 156, 213)",
    cne: "http://localhost:2200",
    reportes: "https://sigat.opensiap.com.ve/api/siap",
    email: "http://localhost:5000",
    alcaldia: "Alcaldía del Municipio Paez",
    correo: "alcaldiadelmunicipioezequielzamora@gmail.com",
    rif: "G-20002730-4",
    logocatastro: "sigat.png",
    admin: 0,
    agylsoft: false,
    espiritu: {
      0: {
        email: "info.admpaez@gmail.com",
        clave: "lblgwzffupxkpjed",
      },
      1: {
        email: "info.alcaldiaesteller@gmail.com",
        clave: "esteller0324",
      },
      2: {
        email: "info.alcaldiaturen@gmail.com",
        clave: "turen123",
      },
      3: {
        email: "info.concejopaez@gmail.com",
        clave: "concejo0324",
      },
      15: {
        email: "info.admguanare@gmail.com",
        clave: "uigxltxiwzhkejdj",
      },
      25: {
        email: "satebcocorreos2022@gmail.com",
        clave: "qggzmgginhjfnspf",
      },
    },
  },
  glara: {
    nombre: "lara",
    conexionpagoweb: `https://lara.pagosweb.com.ve/intra`,
    reportespagoweb: "https://lara.pagosweb.com.ve/intra/paez?",
    adjunto: true,
    declarar_con_deuda: false,
    conexionbackup: "wss://lara.opensiap.com.ve/api/ws",
    conexionsiapactu: "wss://lara.opensiap.com.ve/api/socket",
    servidor: "https://lara.opensiap.com.ve/api",
    conexion: "https://lara.opensiap.com.ve/api",
    conexionmap: "https://lara.opensiap.com.ve/mapa",
    icon: "lara.ico",
    logoEscudo: "escudo_admin.png",
    logologin: "lara.png",
    logohacienda: "lara.png",
    conexionweb: "https://lara.opensiap.com.ve/api",
    municipio: "guanare",
    imagenes: "https://lara.opensiap.com.ve/api",
    imagenreportes: "https://lara.opensiap.com.ve/api",
    color: "rgb(1, 156, 213)",
    cne: "http://localhost:2200",
    reportes: "https://lara.opensiap.com.ve/api/siap",
    email: "http://localhost:5000",
    alcaldia: "Alcaldía del Municipio Ezequiel Zamora",
    correo: "alcaldiadelmunicipioezequielzamora@gmail.com",
    rif: "G-20002730-4",
    logocatastro: "catastrologo.png",
    agylsoft: false,
    espiritu: {
      0: {
        email: "info.admpaez@gmail.com",
        clave: "lblgwzffupxkpjed",
      },
      1: {
        email: "info.alcaldiaesteller@gmail.com",
        clave: "esteller0324",
      },
      2: {
        email: "info.alcaldiaturen@gmail.com",
        clave: "turen123",
      },
      3: {
        email: "info.concejopaez@gmail.com",
        clave: "concejo0324",
      },
      15: {
        email: "info.admguanare@gmail.com",
        clave: "uigxltxiwzhkejdj",
      },
      25: {
        email: "satebcocorreos2022@gmail.com",
        clave: "qggzmgginhjfnspf",
      },
    },
  },
  esteller: {
    nombre: "esteller",
    conexionpagoweb: ` `,

    reportespagoweb: " ",
    adjunto: true,
    declarar_con_deuda: false,
    conexionbackup: "wss://esteller.opensiap.com.ve/api/ws",
    conexionsiapactu: "wss://esteller.opensiap.com.ve/api/socket",
    conexioncapture: " ",
    servidor: "https://esteller.opensiap.com.ve",
    conexion: "https://esteller.opensiap.com.ve/api",
    conexionmap: "https://esteller.opensiap.com.ve/mapa",

    conexionweb: "http://192.168.0.212" + ":2100",
    municipio: "esteller",
    imagenes: "https://esteller.opensiap.com.ve/api",
    imagenreportes: "https://esteller.opensiap.com.ve/api",
    agylsoft: false,
    color: "rgb(1, 156, 213)",
    cne: "http://192.168.0.212" + ":2200",
    reportes: "https://esteller.opensiap.com.ve/api/siap",
    email: "http://localhost" + ":5000",
    icon: "esteller.ico",
    logoEscudo: "",
    logologin: "logo_esteller.png",
    logohacienda: "logo_esteller.png",
    logocatastro: "logo_esteller.png",
    alcaldia: "Alcaldía del Municipio Ezequiel Zamora",
    correo: "alcaldiadelmunicipioezequielzamora@gmail.com",
    rif: "G-20002730-4",
    admin: 0,
    espiritu: {
      0: {
        email: "info.admpaez@gmail.com",
        clave: "lblgwzffupxkpjed",
      },
      1: {
        email: "info.alcaldiaesteller@gmail.com",
        clave: "esteller0324",
      },
      2: {
        email: "info.alcaldiaturen@gmail.com",
        clave: "turen123",
      },
      3: {
        email: "info.concejopaez@gmail.com",
        clave: "concejo0324",
      },
      15: {
        email: "info.admguanare@gmail.com",
        clave: "uigxltxiwzhkejdj",
      },
      25: {
        email: "satebcocorreos2022@gmail.com",
        clave: "qggzmgginhjfnspf",
      },
    },
  },
  turen: {
    nombre: "turen",
    conexionpagoweb: ` `,

    reportespagoweb: " ",
    adjunto: true,
    declarar_con_deuda: false,
    conexionbackup: "wss://turen.opensiap.com.ve/api/ws",
    conexionsiapactu: "wss://turen.opensiap.com.ve/api/socket",
    conexioncapture: " ",
    servidor: "https://turen.opensiap.com.ve",
    conexion: "https://turen.opensiap.com.ve/api",
    conexionmap: "https://turen.opensiap.com.ve/mapa",

    conexionweb: "http://192.168.0.212" + ":2100",
    municipio: "turen",
    imagenes: "https://turen.opensiap.com.ve/api",
    imagenreportes: "https://turen.opensiap.com.ve/api",
    agylsoft: false,
    color: "rgb(1, 156, 213)",
    cne: "http://192.168.0.212" + ":2200",
    reportes: "https://turen.opensiap.com.ve/api/siap",
    email: "http://localhost" + ":5000",
    icon: "turen.ico",
    logoEscudo: "",
    logologin: "logo_turen.png",
    logohacienda: "logo_turen.png",
    logocatastro: "logo_turen.png",
    alcaldia: "Alcaldía del Municipio Ezequiel Zamora",
    correo: "alcaldiadelmunicipioezequielzamora@gmail.com",
    rif: "G-20002730-4",
    admin: 0,
    espiritu: {
      0: {
        email: "info.admpaez@gmail.com",
        clave: "lblgwzffupxkpjed",
      },
      1: {
        email: "info.alcaldiaturen@gmail.com",
        clave: "turen0324",
      },
      2: {
        email: "info.alcaldiaturen@gmail.com",
        clave: "turen123",
      },
      3: {
        email: "info.concejopaez@gmail.com",
        clave: "concejo0324",
      },
      15: {
        email: "info.admguanare@gmail.com",
        clave: "uigxltxiwzhkejdj",
      },
      25: {
        email: "satebcocorreos2022@gmail.com",
        clave: "qggzmgginhjfnspf",
      },
    },
  },
  araure: {
    nombre: "araure",
    conexionpagoweb: ` `,

    reportespagoweb: " ",
    adjunto: true,
    declarar_con_deuda: false,
    conexionbackup: "wss://araure.opensiap.com.ve/api/ws",
    conexionsiapactu: "wss://araure.opensiap.com.ve/api/socket",
    conexioncapture: " ",
    servidor: "https://araure.opensiap.com.ve",
    conexion: "https://araure.opensiap.com.ve/api",
    conexionmap: "https://araure.opensiap.com.ve/mapa",

    conexionweb: "http://192.168.0.212" + ":2100",
    municipio: "araure",
    imagenes: "https://araure.opensiap.com.ve/api",
    imagenreportes: "https://araure.opensiap.com.ve/api",
    agylsoft: false,
    color: "rgb(1, 156, 213)",
    cne: "http://192.168.0.212" + ":2200",
    reportes: "https://araure.opensiap.com.ve/api/siap",
    email: "http://localhost" + ":5000",
    icon: "ara.ico",
    logoEscudo: "",
    logologin: "logoaraure.png",
    logohacienda: "logoaraure.png",
    logocatastro: "logoaraure.png",
    alcaldia: "Alcaldía del Municipio Ezequiel Zamora",
    correo: "alcaldiadelmunicipioezequielzamora@gmail.com",
    rif: "G-20002730-4",
    admin: 0,
    espiritu: {
      0: {
        email: "info.admpaez@gmail.com",
        clave: "lblgwzffupxkpjed",
      },
      1: {
        email: "info.alcaldiaaraure@gmail.com",
        clave: "araure0324",
      },
      2: {
        email: "info.alcaldiaaraure@gmail.com",
        clave: "araure123",
      },
      3: {
        email: "info.concejopaez@gmail.com",
        clave: "concejo0324",
      },
      15: {
        email: "info.admguanare@gmail.com",
        clave: "uigxltxiwzhkejdj",
      },
      25: {
        email: "satebcocorreos2022@gmail.com",
        clave: "qggzmgginhjfnspf",
      },
    },
  },
  sedatel: {
    nombre: "sedatel",
    conexionpagoweb: `https://sedatel.pagosweb.com.ve/intra`,
    reportespagoweb: "https://sedatel.pagosweb.com.ve/intra/sedatel?",
    adjunto: true,
    declarar_con_deuda: false,
    conexionbackup: "wss://sedatel.opensiap.com.ve/api/ws",
    conexionsiapactu: "wss://sedatel.opensiap.com.ve/api/socket",
    servidor: "https://sedatel.opensiap.com.ve/api",
    conexion: "https://sedatel.opensiap.com.ve/api",
    conexionmap: "https://sedatel.opensiap.com.ve/mapa",
    icon: "sedatel.ico",
    logoEscudo: "escudo_admin.png",
    logologin: "sedatel.png",
    logohacienda: "sedatel.png",
    conexionweb: "https://sedatel.opensiap.com.ve/api",
    municipio: "sedatel",
    imagenes: "https://sedatel.opensiap.com.ve/api",
    imagenreportes: "https://sedatel.opensiap.com.ve/api",
    color: "rgb(1, 156, 213)",
    cne: "http://localhost:2200",
    reportes: "https://sedatel.opensiap.com.ve/api/siap",
    email: "http://localhost:5000",
    alcaldia: "Alcaldía del Municipio Ezequiel Zamora",
    correo: "alcaldiadelmunicipioezequielzamora@gmail.com",
    rif: "G-20002730-4",
    logocatastro: "catastrologo.png",
    agylsoft: false,
    espiritu: {
      0: {
        email: "info.admpaez@gmail.com",
        clave: "lblgwzffupxkpjed",
      },
      1: {
        email: "info.alcaldiaesteller@gmail.com",
        clave: "esteller0324",
      },
      2: {
        email: "info.alcaldiaturen@gmail.com",
        clave: "turen123",
      },
      3: {
        email: "info.concejopaez@gmail.com",
        clave: "concejo0324",
      },
      15: {
        email: "info.admguanare@gmail.com",
        clave: "uigxltxiwzhkejdj",
      },
      25: {
        email: "satebcocorreos2022@gmail.com",
        clave: "qggzmgginhjfnspf",
      },
    },
  },
  unda: {
    nombre: "unda",
    conexionpagoweb: ` `,

    reportespagoweb: " ",
    adjunto: true,
    declarar_con_deuda: false,
    conexionbackup: "wss://unda.opensiap.com.ve/api/ws",
    conexionsiapactu: "wss://unda.opensiap.com.ve/api/socket",
    conexioncapture: " ",
    servidor: "https://unda.opensiap.com.ve",
    conexion: "https://unda.opensiap.com.ve/api",
    conexionmap: "https://unda.opensiap.com.ve/mapa",

    conexionweb: "http://192.168.0.212" + ":2100",
    municipio: "unda",
    imagenes: "https://unda.opensiap.com.ve/api",
    imagenreportes: "https://unda.opensiap.com.ve/api",
    agylsoft: false,
    color: "rgb(1, 156, 213)",
    cne: "http://192.168.0.212" + ":2200",
    reportes: "https://unda.opensiap.com.ve/api/siap",
    email: "http://localhost" + ":5000",
    icon: "unda.ico",
    logoEscudo: "",
    logologin: "logo_unda.png",
    logohacienda: "logo_unda.png",
    logocatastro: "logo_unda.png",
    alcaldia: "Alcaldía del Municipio Unda",
    correo: "unda@gmail.com",
    rif: "G-20002730-4",
    admin: 0,
    espiritu: {
      0: {
        email: "info.admpaez@gmail.com",
        clave: "lblgwzffupxkpjed",
      },
      1: {
        email: "info.alcaldiaturen@gmail.com",
        clave: "turen0324",
      },
      2: {
        email: "info.alcaldiaturen@gmail.com",
        clave: "turen123",
      },
      3: {
        email: "info.concejopaez@gmail.com",
        clave: "concejo0324",
      },
      15: {
        email: "info.admguanare@gmail.com",
        clave: "uigxltxiwzhkejdj",
      },
      25: {
        email: "satebcocorreos2022@gmail.com",
        clave: "qggzmgginhjfnspf",
      },
    },
  },
  gestion: {
    nombre: "cppaez",
    ws: "https://comresis.opensiap.com.ve/ws",
    conexionpagoweb: `https://gestion.pagosweb.com.ve/intra`,
    reportespagoweb: "https://gestion.pagosweb.com.ve/intra/gestion?",
    adjunto: true,
    declarar_con_deuda: false,
    conexionbackup: "wss://gestion.opensiap.com.ve/api/ws",
    conexionsiapactu: "wss://gestion.opensiap.com.ve/api/socket",
    conexioncapture: "https://gestion.pagosweb.com.ve",
    servidor: "https://gestion.opensiap.com.ve/api",
    conexion: "https://gestion.opensiap.com.ve/api",
    conexionmap: "https://gestion.opensiap.com.ve/mapa",
    icon: "paez.ico",
    logoEscudo: "",
    logologin: "logopaez.png",
    logohacienda: "logopaez.png",
    conexionweb: "https://gestion.opensiap.com.ve/api",
    municipio: "guanare",
    imagenes: "https://gestion.opensiap.com.ve/api",
    imagenreportes: "https://gestion.opensiap.com.ve/api",
    color: "rgb(1, 156, 213)",
    cne: "http://localhost:2200",
    reportes: "https://gestion.opensiap.com.ve/api/siap",
    email: "http://localhost:5000",
    alcaldia: "Alcaldía del Municipio Paez",
    correo: "alcaldiadelmunicipioezequielzamora@gmail.com",
    rif: "G-20002730-4",
    logocatastro: "catastrologo.png",
    admin: 0,
    agylsoft: false,
    espiritu: {
      0: {
        email: "info.admpaez@gmail.com",
        clave: "lblgwzffupxkpjed",
      },
      1: {
        email: "info.alcaldiaesteller@gmail.com",
        clave: "esteller0324",
      },
      2: {
        email: "info.alcaldiaturen@gmail.com",
        clave: "turen123",
      },
      3: {
        email: "info.concejopaez@gmail.com",
        clave: "concejo0324",
      },
      15: {
        email: "info.admguanare@gmail.com",
        clave: "uigxltxiwzhkejdj",
      },
      25: {
        email: "satebcocorreos2022@gmail.com",
        clave: "qggzmgginhjfnspf",
      },
    },
  },
});

module.exports = CONEXION["paezweb"];
